import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "gp_admin_token";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(t) {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* noop */
  }
}

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const adminApi = {
  login: (email, password) => client.post("/auth/login", { email, password }),
  changePassword: (current_password, new_password) =>
    client.post("/auth/change-password", { current_password, new_password }),
  me: () => client.get("/auth/me"),
  listEnquiries: (params) => client.get("/admin/enquiries", { params }),
  getEnquiry: (id) => client.get(`/admin/enquiries/${id}`),
  patchEnquiry: (id, body) => client.patch(`/admin/enquiries/${id}`, body),
  getContent: () => client.get("/admin/page-content"),
  putContent: (values) => client.put("/admin/page-content", values),
  historyKey: (key) => client.get(`/admin/page-content/history/${encodeURIComponent(key)}`),
  restoreKey: (key, version_id) => client.post("/admin/page-content/restore", { key, version_id }),
  publishAssistant: () => client.post("/admin/assistant/publish"),
  integrationStatus: () => client.get("/admin/integration-status"),
  emailStatus: () => client.get("/admin/email/status"),
  emailTestDelivery: () => client.post("/admin/email/test-delivery"),
  getEvidence: () => client.get("/admin/evidence"),
  putEvidence: (items) => client.put("/admin/evidence", items),
  changeEmail: ({ new_email }) => client.post("/admin/settings/change-email", { new_email }),
  changeMyPassword: (current_password, new_password) => client.post("/admin/settings/change-password", { current_password, new_password }),
  listUsers: () => client.get("/admin/users"),
  inviteUser: ({ email, name }) => client.post("/admin/users", { email, name }),
  revokeUser: (email) => client.delete(`/admin/users/${encodeURIComponent(email)}`),
  regenerateSetupLink: (email) => client.post("/admin/users/setup-link", { email }),
};

export const publicApi = {
  submitEnquiry: (body) => axios.post(`${API}/enquiries`, body),
  getPageContent: () => axios.get(`${API}/public/page-content`),
};
